/**
 * @vuepress
 * ---
 * title: AffectedTransformer
 * ---
 */

import Transformer from '../transformer'

/**
 * @class AffectedTransformer
 * @author Jose Luis R.
 */
class AffectedTransformer extends Transformer {
  static fetch({
    id, name, process_abbreviation: processAbb
  }) {
    return {
      id, name, processAbb
    }
  }
}

export default AffectedTransformer
